import Timer from 'common/modules/middleware/timerMiddleware'

const PopupTimer = Timer({
    reducerName: 'popupTimer',
})

export default PopupTimer
